import {
  DELAYED_DATA_ACTIONS,
  RESET_CONFIG_STATE,
  STATE_STATUS,
} from "./actionTypes";

export const actions = {
  fetchDelayedData: () => {
    return {
      type: DELAYED_DATA_ACTIONS.FETCH_DELAYED_DATA,
      payload: {},
    };
  },

  fetchedDelayedData: (data = {}) => {
    return {
      type: DELAYED_DATA_ACTIONS.FETCHED_DELAYED_DATA,
      payload: {
        data,
      },
    };
  },

  failedFetchDelayedData: (error) => {
    return {
      type: DELAYED_DATA_ACTIONS.FAILED_FETCH_DELAYED_DATA,
      payload: {
        error,
      },
    };
  },

  resetDeliveryReview: () => {
    return {
      type: DELAYED_DATA_ACTIONS.RESET_DELIVERY_REVIEW,
    };
  },

  updateDeliveryFlowInfo: (payload = {}) => {
    return {
      type: DELAYED_DATA_ACTIONS.DELIVERY_FLOW_ENABLED,
      payload,
    };
  },

  getDeliveryFlowInfoData: () => {
    return {
      type: DELAYED_DATA_ACTIONS.GET_DELIVERY_INFO,
      payload: {},
    };
  },
  confirmDevice: (payload) => {
    return {
      type: DELAYED_DATA_ACTIONS.CONFIRM_LOGIN_DEVICE,
      payload,
    };
  },
  updateCpAvailabilityModal: (payload) => {
    return { type: DELAYED_DATA_ACTIONS.UPDATE_CP_AVAILABILITY_MODAL, payload };
  },
};

const initialState = {
  status: STATE_STATUS.UNFETCHED,
  viewCartLight: {},
  walletBalance: {},
  kjNextSpin: {},
  showInAppRating: {},
  cxOrderRating: false,
  profileAddress: {},
  cxReviewOptions: {},
  error: null,
  deliveryRatingDetails: {},
  deliveryFlowEnabled: false,
  deliveryFlowInfo: {
    ordersCount: 0,
    orders: [],
    meta: {},
  },
  cpAvailabilityModal: { chip: null, modal: null },
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case DELAYED_DATA_ACTIONS.FETCH_DELAYED_DATA:
      return {
        ...state,
        status: STATE_STATUS.FETCHING,
      };

    case DELAYED_DATA_ACTIONS.FETCHED_DELAYED_DATA: {
      const { payload } = action;
      return {
        ...state,
        ...payload.data,
        status: STATE_STATUS.FETCHED,
      };
    }

    case DELAYED_DATA_ACTIONS.FAILED_FETCH_DELAYED_DATA: {
      const { payload } = action;
      return {
        ...state,
        error: payload.error,
      };
    }

    case DELAYED_DATA_ACTIONS.RESET_DELIVERY_REVIEW: {
      return {
        ...state,
        deliveryRatingDetails: {
          shouldShowDeliveryRatingModal: false,
          deliveryRatingTemplate: {},
        },
      };
    }

    case DELAYED_DATA_ACTIONS.DELIVERY_FLOW_ENABLED: {
      const { payload } = action;
      return {
        ...state,
        deliveryFlowEnabled:
          payload?.deliveryFlowEnabled ?? state.deliveryFlowEnabled,
        deliveryFlowInfo: payload?.deliveryFlowInfo ?? state.deliveryFlowInfo,
      };
    }

    case DELAYED_DATA_ACTIONS.CONFIRM_LOGIN_DEVICE: {
      return {
        ...state,
        activeDevicesInfo: { ...state.activeDevicesInfo, devices: null },
      };
    }

    case DELAYED_DATA_ACTIONS.UPDATE_CP_AVAILABILITY_MODAL: {
      const { payload } = action;
      return { ...state, cpAvailabilityModal: payload };
    }

    case RESET_CONFIG_STATE: {
      return initialState;
    }

    default:
      return state;
  }
}
reducer.initialState = initialState;
export default reducer;
